<template>
    <div class="flex flex-col sm:flex-row sm:items-center pb-4 pt-2 px-5 bg-gray-warm-100">
        <div class="flex items-center mt-2 mb-4 sm:mt-6 sm:mb-0 mr-1">
            <i class="fa fa-search mr-3"
                :class="has_active_filters ? 'text-blue-500' : 'text-gray-600'"
            ></i>

            <span class="block sm:hidden text-gray-600">Filter by</span>
        </div>

        <div class="flex-1 flex flex-col sm:items-center sm:flex-row">
            <div class="flex-1 sm:mr-4">
                <input-text
                    :label="$t('Client Name')"
                    label_class="text-xs text-gray-600 uppercase tracking-widest inline-block leading-snug font-semibold"
                    :value="filter_by_name"
                    @input="$emit('filterByName', $event)"
                />
            </div>

            <div class="flex-1 sm:mr-4">
                <input-text
                    :label="$t('Property Address')"
                    label_class="text-xs text-gray-600 uppercase tracking-widest inline-block leading-snug font-semibold"
                    :value="filter_by_address"
                    @input="$emit('filterByAddress', $event)"
                />
            </div>

            <div class="flex-1 sm:mr-4">
                <input-text
                    :label="$t('Closing Month')"
                    label_class="text-xs text-gray-600 uppercase tracking-widest inline-block leading-snug font-semibold"
                    :value="filter_by_closing_month"
                    @input="$emit('filterByClosingMonth', $event)"
                />
            </div>
        </div>

        <div class="text-right text-xs tracking-widest font-semibold uppercase cursor-pointer select-none mt-5 mx-1"
            :class="has_active_filters
                ? 'text-blue-500 hover:text-blue-700'
                : 'text-gray-500'
            "
            @click="$emit('clearFilters')"
        >
            {{ $t('Clear') }} <span class="hidden md:inline-block">{{ $t('Filters') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        properties: {},
        has_active_filters: { default: false },
        filter_by_broker: {},
        filter_by_name: {},
        filter_by_address: {},
        filter_by_closing_month: {},
    },

    data() {
        return {
            selected_broker_id: null,
        }
    },

    watch: {
        selected_broker_id(value) {
            this.$emit('filterByBroker', value);
        },
    },
}
</script>
